// src/config.js
//const BASE_URL = 'http://localhost:5001/api';
const BASE_URL = 'https://reactapi.kit-react.de/api';
export default BASE_URL;
